import { useState, useEffect } from "react";

export function useRecurlyLoader() {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (window.recurly) {
      setLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://js.recurly.com/v4/recurly.js";
    script.async = true;

    script.onload = () => {
      setLoaded(true);
    };

    script.onerror = () => {
      setError("Failed to load Recurly.js");
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return { loaded, error };
}
